import { EvaluatedAction, ManualAction } from "./EvaluatedAction.js";



export const UserCTAEventNames = {

    UNDERFOLLOW_SHOWN: "CTAUnderfollowShown",
    UNDERFOLLOW_COMPLETE: "CTAComplete",
    UNDERFOLLOW_DISMISS: "CTADismiss"
};


export interface UserCTAEvents {

    onUnderfollowShown(fun: () => void): void;
    onCTAComplete(fun: () => void): void;
    onCTADismiss(fun: () => void): void;
    signalNonUserDismiss(): void;
}

export interface UserCTALogic extends UserCTAEvents {


    evaluateCTA(): Promise<EvaluatedAction<any>>

    execCTA(): Promise<void>

    forceActionExecution(action: ManualAction): Promise<void>;

}